import React from "react";

import { Column } from "Components/AppGrid/shipeezi-new-grid";
import BadgeStatus from "Components/Generic/BadgeStatus";
import { Fleet } from "Models/fleet";
import { Member } from "Models/member";
import { Team } from "Models/team";
import { TFunction } from "react-i18next";
import { Status } from "Util/enums";
import { getEquipmentName } from "Util/getEquipmentName";

import { MembersComponent } from "./styles";

interface GetTeamTableColumnsParams {
  translate: TFunction<"translation", undefined>;
}

export const getTeamTableColumns = (params: GetTeamTableColumnsParams) => {
  const { translate } = params;
  const columns: Column[] = [
    {
      name: "name",
      title: translate("name"),
    },
    {
      name: "members",
      hideSearch: true,
      hideSort: true,
      title: translate("members"),
      formatComponent: (members: Member[], row: Team) => {
        const membersWithoutLeader = (members || []).filter(
          (member) => member.id !== row?.memberLeaderId
        );

        if (row?.memberLeader) {
          return (
            <MembersComponent>
              <span>
                {translate("leader")}: {row.memberLeader?.fullName}
              </span>
              {membersWithoutLeader.length ? (
                <span>
                  {translate("staffs")}:{" "}
                  {membersWithoutLeader?.map((member) => member.firstName).join(", ")}
                </span>
              ) : null}
            </MembersComponent>
          );
        }
        if (membersWithoutLeader?.length) {
          return membersWithoutLeader.map((member) => member.firstName).join(", ");
        }

        return "-";
      },
    },
    {
      name: "fleets",
      hideSearch: true,
      hideSort: true,
      title: translate("equipments"),
      formatComponent: (fleets: Fleet[]) => {
        if (fleets?.length) {
          return fleets
            .map((fleet) => {
              const { fullText } = getEquipmentName(fleet);

              return fullText;
            })
            .join(", ");
        }

        return "-";
      },
    },
    {
      name: "isActive",
      title: translate("status"),
      hideSearch: true,
      formatComponent: (isActive: boolean) => (
        <BadgeStatus value={isActive ? Status.ACTIVE : Status.INACTIVE} />
      ),
      hideSort: true,
    },
  ];

  return columns;
};
